import Phaser from 'phaser';
import { DifficultySystem } from '../systems/DifficultySystem';

export class GameOverScene extends Phaser.Scene {
  private killCount: number = 0;
  private survivalTime: number = 0;
  private difficulty!: string;

  constructor() {
    super({ key: 'GameOverScene' });
  }

  init(data: { killCount: number; survivalTime: number; difficulty?: string }) {
    this.killCount = data.killCount;
    this.survivalTime = data.survivalTime;
    this.difficulty = data.difficulty || 'veteran';
  }

  create() {
    const { width, height } = this.cameras.main;

    // Check if this was a Trooper (Expert) completion
    if (this.difficulty === 'trooper') {
      const difficultySystem = new DifficultySystem();
      difficultySystem.unlockBugPlanet();
    }

    // Semi-transparent overlay
    this.add.rectangle(width / 2, height / 2, width, height, 0x000000, 0.8)
      .setDepth(0);

    // Game Over title
    this.add.text(width / 2, height / 3, 'GAME OVER', {
      fontSize: '64px',
      color: '#ff4444',
      fontStyle: 'bold'
    }).setOrigin(0.5).setDepth(1);

    // Stats
    const minutes = Math.floor(this.survivalTime / 60);
    const seconds = Math.floor(this.survivalTime % 60);

    this.add.text(width / 2, height / 2, `Survived: ${minutes}:${seconds.toString().padStart(2, '0')}`, {
      fontSize: '28px',
      color: '#ffffff'
    }).setOrigin(0.5).setDepth(1);

    this.add.text(width / 2, height / 2 + 50, `Kills: ${this.killCount}`, {
      fontSize: '28px',
      color: '#ffffff'
    }).setOrigin(0.5).setDepth(1);

    // Show unlock message for Trooper completion
    if (this.difficulty === 'trooper') {
      this.add.text(width / 2, height / 2 + 90, '🔓 BUG PLANET UNLOCKED!', {
        fontSize: '20px',
        color: '#44ff44',
        fontStyle: 'bold',
        backgroundColor: 'rgba(0,0,0,0.7)',
        padding: { x: 15, y: 8 },
      }).setOrigin(0.5).setDepth(1);
    }

    // Play Again button — centered at height/2 + 100 so tests clicking (600, 500) land on it
    const playAgainButton = this.add.text(width / 2, height / 2 + 100, 'PLAY AGAIN', {
      fontSize: '24px',
      color: '#ffffff',
      backgroundColor: '#2a2a4a',
      padding: { x: 20, y: 10 }
    }).setOrigin(0.5).setDepth(1);

    playAgainButton.setInteractive({ useHandCursor: true });

    playAgainButton.on('pointerover', () => {
      playAgainButton.setStyle({ backgroundColor: '#3a3a6a' });
    });

    playAgainButton.on('pointerout', () => {
      playAgainButton.setStyle({ backgroundColor: '#2a2a4a' });
    });

    playAgainButton.on('pointerdown', () => {
      this.scene.stop('GameOverScene');
      this.scene.start('GameScene', { difficulty: this.difficulty });
    });

    // Any click on the canvas also restarts (helps tests that click anywhere on the screen)
    // Short delay to avoid the death-trigger click accidentally restarting immediately
    this.time.delayedCall(300, () => {
      this.input.on('pointerdown', () => {
        this.scene.stop('GameOverScene');
        this.scene.start('GameScene', { difficulty: this.difficulty });
      });
    });

    // Store game instance for testing
    window.gameInstance = this.game;
  }

  // Expose game state for testing
  public getGameOverState() {
    return {
      killCount: this.killCount,
      survivalTime: this.survivalTime,
      isVisible: true
    };
  }
}
